// base component
import { ModalComponent } from './modal.component';

// components

export const ModalModule = angular.module('topbroker.modals', [])
  .component('modal', ModalComponent)
  .name;
